import { storeToRefs, defineStore } from 'pinia';
import useAvatarStore from '@store/avatar';
const name = 'PopMessage';

const usePopMessageStore = defineStore(name, {
  state: () => ({
    isShow: false as boolean,
    timesOut: 4000 as number,
    type: '' as string,
    title: '' as string,
    message: '' as string,
    isShowGlobalLoading: false as boolean,
    code: -1 as number,
  }),

  actions: {
    hide() {
      this.$reset();
    },
    show(parmas: {
      type: string;
      message: string;
      title?: string;
      timesOut?: number;
      code?: number;
    }) {
      const avatarStore = useAvatarStore();
      const { isGenLoading } = storeToRefs(avatarStore);

      // 弹窗时，非 success 状态 Gen Loading 需要隐藏
      if (parmas.type !== 'success') {
        isGenLoading.value = false;
      }

      this.isShow = true;
      this.type = parmas.type;
      this.message = parmas.message;

      if (parmas.code) {
        this.code = parmas.code;
      } else {
        this.code = -1;
      }

      if (parmas.title) {
        this.title = parmas.title;
      }

      if (parmas.timesOut) {
        this.timesOut = parmas.timesOut;
      }

      setTimeout(() => {
        this.hide();
      }, this.timesOut);
    },
    showGlobalLoading() {
      this.isShowGlobalLoading = true;
    },
  },
});

export default usePopMessageStore;
